// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInputForDisplay_input__3UjIC","label":"TextInputForDisplay_label__1XMO8"};